import React, {
  useState,
  useMemo,
  useEffect,
  useCallback,
  useContext,
  Fragment,
} from 'react'
import moment from 'moment'
import { withRouter } from 'react-router-dom'
import { withStyles } from '@material-ui/core'
import { Box, Button, Typography } from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add'

import {
  CampaignsTotals,
  NewCampaignCard,
  DashboardsFilters,
} from '../Components'
import { debounce } from 'shared/libraries/utils/func'
import { SnackBarContext } from 'Components/SnackBar'
import { PageTitle } from 'Components/PageTitle'
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator'
import {
  fetchCampaignsData,
  fetchCampaignsDashboardData,
  fetchClientCampaignsList,
  fetchCountOfCalculatedCampaigns,
} from 'Containers/Campaigns/gql.js'
import { downloadStringAsFile } from 'Utils/Misc/index'

import { PATHS } from 'Config/Routing/paths'
import {
  CAMPAIGN_ENUM_TYPES,
  CAMPAIGN_LOG_ENUM_TYPES,
  CAMPAIGN_TYPE_PARAM_TO_ENUM,
  CAMPAIGN_TYPE_PARAM_TO_CAMPAIGNS_DASHBOARD_TITLE,
  STATUS_CAMPAIGN_ENUM_ACTIVE,
  STATUS_CAMPAIGN_ENUM_ARCHIVE,
  STATUS_CAMPAIGN_ENUM_COMPLETED,
  STATUS_CAMPAIGN_ENUM_DRAFT,
  DocumentFormats,
  ADM_DOCUMENTS_FORMATS,
  EDDM_DOCUMENT_FORMATS,
  CAMPAIGN_ENUM_TYPES_TO_TITLE,
  CAMPAIGN_TYPE_PARAM_TO_ENABLED_CHANNEL,
  CAMPAIGN_TYPE_PARAM_TO_CHANNEL,
  CAMPAIGN_SUBTYPES_ENUM,
  EDDM_SIGNUP,
} from '../../../shared/constants'
import {
  // LIST_VIEW,
  // MENU_ITEMS,
  STATUS_FILTER_OPTIONS,
  SORTING_OPTIONS,
  STATUS_OPTIONS_PRIORITY,
  OPPIZI_ADS_STATUS_FILTER_OPTIONS,
  STATUS_OPTIONS_PRIORITY_V2,
} from '../constants'
import {
  getBaseCampaignName,
  getCampaignDashboardUrl,
} from '../../../Utils/Campaigns'
import { ExportIcon } from '../../../Assets/Images/icons/ExportIcon'

import styles from './style.js'
import {
  getClientById,
  getCountryDefaultSettings,
  createSSCampaign,
  duplicateUSEDDMCampaign,
} from './gql'
import useGraphQLFetch from '../../../Utils/Hooks/useGraphQLFetch'
import { authorization } from '../../../Module/Auth/Auth'
import { updateCampaign } from '../../../Module/graphQL'
import {
  addAuthParamsToCampaignBuilderUrl,
  getCampaignBuilderPageUrl,
  openLinkInSameTab,
} from '../../../Containers/Country/Page/Pipeline/PipelineView/utils'
import { gtagWrapper } from '../../../Utils/Functions'
import { onFiltersChange } from './utils'
import useCampaignPosthogAnalytics from './hooks/useCampaignPosthogAnalytics'
import { getCampaignStartDate } from '../Components/CampaignCard/utils'
import { getReadableInternalStatusV1 } from '../../StatusLabel'
import { getReadableStatus } from '../../../Containers/Campaigns/utils'
import { insertCampaignLogs } from '../../../Logs/campaign/gql'
import { CONFIG } from '../../../Config/config'
import StyledBreadcrumbs from '../../StyledBreadcrumbs'
import { CampaignIcon } from '../../../Assets/Images/icons/CampaignIcon'
import EmptyStateRouteManager from '../Components/EmptyStateRouteManager/index.js'
import { EmptyStateDropdownBtn } from '../Components/CampaignEmptyStateButtons/index.js'
import classNames from 'classnames'
import { useWrappedPosthog } from '../../PostHogProvider/hooks.js'
import { useFeatureFlags } from '../../../Context/FeatureFlagsContext'
import { apiDashboardsClient } from '../../../Module/APIDashboards/Client'
import { CAMPAIGN_VIEW_FILTER_TYPE } from './constants.js'

const CampaignView = ({ classes, client, type, subType }) => {
  const posthog = useWrappedPosthog()
  const { isAdmEnabled } = useFeatureFlags()
  const isDmEnabled = client.countryId === 14
  const subTypeEnum = subType ? subType.toUpperCase() : null
  const isAdm = subTypeEnum === CAMPAIGN_SUBTYPES_ENUM.ADM
  const isEddm = subTypeEnum === CAMPAIGN_SUBTYPES_ENUM.EDDM

  const shouldFetchCampaignsByType = useMemo(
    () =>
      !!type &&
      type !== 'campaign' &&
      type !== CAMPAIGN_VIEW_FILTER_TYPE.ACTIVE_CAMPAIGNS,
    [type],
  )

  const channel = useMemo(() => {
    const typeKey = isAdm || isEddm ? subType : type
    return CAMPAIGN_TYPE_PARAM_TO_CHANNEL[typeKey]
  }, [isAdm, isEddm, subTypeEnum, type])

  const shouldFetchActiveCampaigns = useMemo(
    () => type && type === CAMPAIGN_VIEW_FILTER_TYPE.ACTIVE_CAMPAIGNS,
    [type],
  )

  const sortOptions =
    shouldFetchActiveCampaigns && isDmEnabled
      ? SORTING_OPTIONS.filter(option => option.value !== 'status')
      : SORTING_OPTIONS

  const allowedOrigins = [CONFIG.NEXT_BASE_URL]

  const { id: clientId } = client
  let controller

  useEffect(() => {
    const handleMessageOld = event => {
      if (allowedOrigins.includes(event.origin) && event.data === 'message') {
        const token = JSON.stringify(localStorage.apiKey)
        event.source.postMessage(token, event.origin)
      }
    }
    window.addEventListener('message', handleMessageOld)

    return () => {
      window.removeEventListener('message', handleMessageOld)
    }
  }, [])
  const runSnackBar = useContext(SnackBarContext)
  const { emitAnalyticsEvent } = useCampaignPosthogAnalytics(posthog)
  const { id: userId } = authorization.getUser()
  const isEddmSignup = !!client && client.createdBy === EDDM_SIGNUP

  const [exportContent, setExportContent] = useState('')
  const [campaignCalculatedData, setCampaignCalculatedData] = useState([])
  const [listOfAllClientCampaigns, setListOfAllClientCampaigns] = useState(null)
  const [campaignsList, setCampaignsList] = useState([])
  const [filteredCampaignsList, setFilteredCampaignsList] = useState([])
  const [aborted, setAborted] = useState(false)
  const [sortByValue, setSortByValue] = useState(sortOptions[0].value)
  // false = ASC / true = DESC
  const [sortDirection, setSortDirection] = useState(true)
  const [isSelfServeEnabled, setIsSelfServeEnabled] = useState(false)
  const [isCreatingCampaign, setIsCreatingCampaign] = useState(false)
  const [countrySettings, setCountrySettings] = useState({})
  const [
    isLoadingCampaignCalculatedData,
    setIsLoadingCampaignCalculatedData,
  ] = useState(true)
  const [
    isLoadingCampaignsSimpleData,
    setIsLoadingCampaignsSimpleData,
  ] = useState(true)
  const [campaignOptions, setCampaignOptions] = useState()
  const [selectedFilters, setSelectedFilters] = useState({
    startDate: null,
    endDate: null,
    statuses: [null],
    types: null,
  })

  const shouldDisplayEmptyState = () => {
    const nonArchivedCampaigns = listOfAllClientCampaigns
      ? listOfAllClientCampaigns.filter(
          campaign =>
            campaign.status !== STATUS_CAMPAIGN_ENUM_ARCHIVE &&
            (type === CAMPAIGN_VIEW_FILTER_TYPE.ACTIVE_CAMPAIGNS ||
              campaign.type === CAMPAIGN_TYPE_PARAM_TO_ENUM[type]),
        )
      : []

    if (shouldFetchActiveCampaigns) {
      return (
        nonArchivedCampaigns.length &&
        !!nonArchivedCampaigns.filter(
          campaign => campaign.status === STATUS_CAMPAIGN_ENUM_ACTIVE,
        ).length
      )
    } else if (shouldFetchCampaignsByType) {
      if (isAdm || isEddm) {
        return (
          nonArchivedCampaigns.length &&
          !!nonArchivedCampaigns.filter(
            campaign => campaign.subtype === subTypeEnum,
          ).length
        )
      }
      return !!nonArchivedCampaigns.length
    } else {
      return !!nonArchivedCampaigns.length
    }
  }

  const disableSortDirection = useMemo(
    () =>
      filteredCampaignsList.length === 1 ||
      (sortByValue === 'status' &&
        selectedFilters.statuses.length === 1 &&
        !!selectedFilters.statuses[0]),
    [sortByValue, selectedFilters],
  )

  const { data, isLoaded } = useGraphQLFetch({
    fetchFn: getClientById,
    defaultFetchArgs: clientId,
    mapResponse: data => data.clientHasAccessToSelfServe,
  })

  const initCountrySettings = async () => {
    const countryDefaultSettings = await getCountryDefaultSettings({
      countryId: client.countryId,
    })

    const newCampaignCTAOptions = []
    if (countryDefaultSettings.enabledChannelEddm) {
      newCampaignCTAOptions.push({
        type: CAMPAIGN_ENUM_TYPES.DIRECTMAIL,
        subtype: CAMPAIGN_SUBTYPES_ENUM.EDDM,
      })
    }
    if (countryDefaultSettings.enabledChannelAdm && isAdmEnabled) {
      newCampaignCTAOptions.push({
        type: CAMPAIGN_ENUM_TYPES.DIRECTMAIL,
        subtype: CAMPAIGN_SUBTYPES_ENUM.ADM,
      })
    }
    if (countryDefaultSettings.enabledChannelLetterbox) {
      newCampaignCTAOptions.push({
        type: CAMPAIGN_ENUM_TYPES.LETTERBOX,
      })
    }
    if (countryDefaultSettings.enabledChannelPreciseLocations) {
      newCampaignCTAOptions.push({
        type: CAMPAIGN_ENUM_TYPES.HANDTOHAND,
      })
    }
    const campaignCTAOptions =
      isEddmSignup && countryDefaultSettings.enabledChannelEddm
        ? [
            {
              type: CAMPAIGN_ENUM_TYPES.DIRECTMAIL,
              subtype: CAMPAIGN_SUBTYPES_ENUM.EDDM,
            },
          ]
        : newCampaignCTAOptions
    setCampaignOptions(campaignCTAOptions)
    setCountrySettings(countryDefaultSettings)
  }

  const checkIsSelfServeEnabled = countrySettings => {
    const user = authorization.getUser()
    const isAdmin = authorization.isAdmin()
    const client = user.client || {}

    if (client.isSelfServeEnabled !== data || isAdmin) {
      authorization.updateUser({
        ...user,
        client: { ...client, isSelfServeEnabled: data },
      })
    }

    if (Object.values(countrySettings).some(setting => setting) && data) {
      setIsSelfServeEnabled(true)
    }
  }

  useEffect(() => {
    if (isLoaded) {
      initCountrySettings()
    }
  }, [isLoaded])

  useEffect(() => {
    if (isLoaded) {
      checkIsSelfServeEnabled(countrySettings)
    }
  }, [countrySettings])

  useEffect(() => {
    emitAnalyticsEvent('Viewed channel page', null, {
      channel,
    })
  }, [type, subType])

  const isLoading =
    !listOfAllClientCampaigns ||
    isLoadingCampaignCalculatedData ||
    isLoadingCampaignsSimpleData ||
    isCreatingCampaign

  // const campaignsTotalMenuItems = [
  //   {
  //     label: `Change to ${LIST_VIEW.MONTHLY} display`,
  //     value: MENU_ITEMS.changeListView,
  //     handleClick: () => switchToCampaignView(),
  //   },
  //   {
  //     label: 'Export in a CSV',
  //     value: 'export',
  //     handleClick: () => handleExport(),
  //   },
  // ]

  const filters = useMemo(() => {
    if (isEddmSignup) {
      return []
    }
    const basicFilters = [
      {
        label: 'Status',
        key: 'statuses',
        options: client.isSelfServeEnabled
          ? OPPIZI_ADS_STATUS_FILTER_OPTIONS
          : [
              ...STATUS_FILTER_OPTIONS.map(item => ({
                ...item,
                label:
                  item.label === 'Draft' ? 'Draft (In Review)' : item.label,
              })),
            ],
        type: 'select',
        multiple: true,
      },
      {
        label: 'Channel',
        key: 'types',
        type: 'select',
        options: [
          {
            label: 'All',
            value: null,
          },
          {
            label: 'H2H',
            value: CAMPAIGN_ENUM_TYPES.HANDTOHAND,
          },
          {
            label: 'D2D',
            value: CAMPAIGN_ENUM_TYPES.LETTERBOX,
          },
          {
            label: 'DM',
            value: CAMPAIGN_ENUM_TYPES.DIRECTMAIL,
          },
          {
            label: 'AIM',
            value: CAMPAIGN_ENUM_TYPES.INSERTS,
          },
        ],
      },
    ]

    if (shouldFetchCampaignsByType) {
      basicFilters.pop()
    } else if (shouldFetchActiveCampaigns) {
      basicFilters.shift()
    }

    return basicFilters
  }, [
    client.isSelfServeEnabled,
    shouldFetchCampaignsByType,
    shouldFetchActiveCampaigns,
    isDmEnabled,
  ])

  const handleSortingChange = useCallback(
    value => {
      let newSortingDirection = false
      // By default sort by date should have DESC direction. Status and name sorting ASC
      if (value === 'startDate') {
        newSortingDirection = true
      }
      setSortDirection(newSortingDirection)
      setSortByValue(value)
      setFilteredCampaignsList(
        sortData(filteredCampaignsList, value, newSortingDirection),
      )
    },
    [filteredCampaignsList, sortDirection],
  )

  const handleSortDirectionChange = () => {
    if (disableSortDirection) {
      return
    }
    setSortDirection(!sortDirection)
    setFilteredCampaignsList(
      sortData(filteredCampaignsList, sortByValue, !sortDirection),
    )
  }

  const handleFiltersChange = (key, label, value) => {
    let newSelectedFilters
    if (label === 'Status') {
      if (value.length && value[value.length - 1] !== null) {
        const newValue = value.filter(item => item !== null)
        newSelectedFilters = {
          ...selectedFilters,
          ...{
            [key]: newValue,
          },
        }
      } else {
        newSelectedFilters = {
          ...selectedFilters,
          [key]: [null],
        }
      }
    } else {
      newSelectedFilters = { ...selectedFilters, ...{ [key]: value } }
    }
    onFiltersChange({
      newSelectedFilters,
      campaignsList,
      filteredCampaignsList,
      setFilteredCampaignsList,
      isSelfServeEnabled,
      sortByValue,
      sortData,
      sortDirection,
    })
    setSelectedFilters(newSelectedFilters)
  }

  const clearAllFilters = () => {
    if (
      (selectedFilters.statuses && selectedFilters.statuses[0]) ||
      selectedFilters.types
    ) {
      const newSelectedFilters = {
        startDate: null,
        endDate: null,
        statuses: [null],
        types: null,
      }

      onFiltersChange({
        newSelectedFilters,
        campaignsList,
        filteredCampaignsList,
        setFilteredCampaignsList,
        isSelfServeEnabled,
        sortData,
        sortByValue,
        sortDirection,
      })
      setSelectedFilters(newSelectedFilters)
    }
  }

  const handleExport = () => {
    if (isLoading) {
      return runSnackBar({
        type: 'warning',
        msg: `Please wait until data is loading`,
      })
    }
    downloadStringAsFile(exportContent, 'Campaign.csv', 'text/csv')
  }

  // const switchToCampaignView = () =>
  //   props.history.push(
  //     `${props.match.path.split(':type')[0]}${LIST_VIEW.MONTHLY}`,
  //   )

  // const sortByHardCosts = useCallback(
  //   newCampaignCalculatedData => {
  //     const campaignsListWithCosts = filteredCampaignsList.map(campaign => {
  //       const campaignCalculatedData = newCampaignCalculatedData.find(
  //         campaignData => campaignData.id === campaign.id,
  //       )
  //       if (campaignCalculatedData) {
  //         return { ...campaign, costs: campaignCalculatedData.costs }
  //       }
  //       return campaign
  //     })
  //     setFilteredCampaignsList(sortData(campaignsListWithCosts, sortByValue))
  //   },
  //   [filteredCampaignsList],
  // )

  const getCountOfCalculatedCampaigns = async () => {
    return await fetchCountOfCalculatedCampaigns()
  }

  const availableCampaignStatusesForClientRoles = [
    STATUS_CAMPAIGN_ENUM_DRAFT,
    STATUS_CAMPAIGN_ENUM_ACTIVE,
    STATUS_CAMPAIGN_ENUM_COMPLETED,
  ]

  const fetchCampaignCardDashboardData = async campaign => {
    try {
      const cardDashboardData = await apiDashboardsClient.fetchCampaignCardDashboardData(
        campaign.id,
      )
      const scansResult = cardDashboardData.scansResult || {}
      const metricsResult = cardDashboardData.metricsResult || {}

      return {
        flyersDistributed:
          (scansResult.flyersInserted && scansResult.flyersInserted.value) || 0,
        scans: (scansResult.quantity && scansResult.quantity.value) || 0,
        progressScore:
          (scansResult.insertingProgress &&
            scansResult.insertingProgress.value) ||
          0,
        metrics:
          metricsResult.metric && metricsResult.metric.metricName
            ? [
                {
                  isPrimary: true,
                  name: metricsResult.metric.metricName || '',
                  label: metricsResult.metric.metricName || '',
                  metricValue: metricsResult.metric.value || 0,
                  conversionRate:
                    (metricsResult.cvr && metricsResult.cvr.value) || 0,
                  costPerMetric:
                    (metricsResult.cpa && metricsResult.cpa.value) || 0,
                },
              ]
            : [],
      }
    } catch (error) {
      console.error('Error fetching campaign card data:', error)
      return campaign
    }
  }

  const applyCampaignShadowFilter = (data, userId) => {
    if (userId == '353634') {
      const newData = data.filter(campaign => campaign.id == '7274')
      return newData
    }
    return data
  }

  const fetchCampaignCalculatedData = async (
    newVariables = {},
    newData = [],
    needToFetchClientCampaignsList = true,
  ) => {
    const filterType = shouldFetchCampaignsByType
      ? [CAMPAIGN_TYPE_PARAM_TO_ENUM[type]]
      : null

    const filterStatus = shouldFetchActiveCampaigns
      ? [STATUS_CAMPAIGN_ENUM_ACTIVE]
      : selectedFilters.statuses[0] !== null
      ? selectedFilters.statuses
      : availableCampaignStatusesForClientRoles

    const filterSubType =
      isAdm || isEddm
        ? [subTypeEnum]
        : isEddmSignup
        ? [CAMPAIGN_SUBTYPES_ENUM.EDDM]
        : null
    const isCalculatedCampaignsDataExists = await getCountOfCalculatedCampaigns()

    controller = new AbortController()

    const variables = {
      clientIds: [clientId],
      ...selectedFilters,
      statuses: filterStatus,
      types: filterType,
      subtypes: filterSubType,
      first: isCalculatedCampaignsDataExists ? 50 : 1,
      skip: 0,
      ...newVariables,
    }
    try {
      const { hasNextPage, data } = await fetchCampaignsDashboardData(
        variables,
        controller.signal,
      )
      if (needToFetchClientCampaignsList) {
        const clientCampaignsListResponse = await fetchClientCampaignsList({
          clientIds: [clientId],
        })
        setListOfAllClientCampaigns(clientCampaignsListResponse || [])
      }

      let processedData = data
      processedData = applyCampaignShadowFilter(processedData, userId)

      if (
        data.some(
          campaign =>
            campaign.type === CAMPAIGN_ENUM_TYPES.INSERTS ||
            campaign.type === CAMPAIGN_ENUM_TYPES.DIRECTMAIL,
        )
      ) {
        processedData = await Promise.all(
          data.map(async campaign => {
            const dashboardData = await fetchCampaignCardDashboardData(campaign)
            return {
              ...campaign,
              ...dashboardData,
            }
          }),
        )
      }

      const newCampaignCalculatedData = [...newData, ...processedData]
      setCampaignCalculatedData(newCampaignCalculatedData)

      if (hasNextPage) {
        fetchCampaignCalculatedData(
          {
            ...variables,
            skip: (variables.skip || 0) + variables.first,
          },
          newCampaignCalculatedData,
          false,
        )
      } else {
        setIsLoadingCampaignCalculatedData(false)
      }
    } catch (error) {}
  }

  const sortData = (data, sortBy, direction) => {
    if (!data.length) return []

    let newData = [...data]

    switch (sortBy) {
      case 'status':
        newData = newData.sort((a, b) => {
          if (client.isSelfServeEnabled) {
            const aReadbleStatus =
              getReadableInternalStatusV1(
                a.selfServeData[0] ? a.selfServeData[0].internalStatus : null,
              ) || getReadableStatus(a.status)
            const bReadbleStatus =
              getReadableInternalStatusV1(
                b.selfServeData[0] ? b.selfServeData[0].internalStatus : null,
              ) || getReadableStatus(b.status)

            const result = direction
              ? STATUS_OPTIONS_PRIORITY_V2[bReadbleStatus.toLowerCase()] -
                STATUS_OPTIONS_PRIORITY_V2[aReadbleStatus.toLowerCase()]
              : STATUS_OPTIONS_PRIORITY_V2[aReadbleStatus.toLowerCase()] -
                STATUS_OPTIONS_PRIORITY_V2[bReadbleStatus.toLowerCase()]
            return result
          } else {
            return direction
              ? STATUS_OPTIONS_PRIORITY[b[sortBy]] -
                  STATUS_OPTIONS_PRIORITY[a[sortBy]]
              : STATUS_OPTIONS_PRIORITY[a[sortBy]] -
                  STATUS_OPTIONS_PRIORITY[b[sortBy]]
          }
        })
        return newData
      case 'name':
        newData = newData.sort((a, b) =>
          a[sortBy].toLowerCase().localeCompare(b[sortBy].toLowerCase()),
        )
        return direction ? newData.reverse() : newData
      case 'startDate':
        const campaignsWithoutStartDate = newData.filter(
          c => !getCampaignStartDate(c),
        )
        const campaignsWithStartDate = newData.filter(
          c => !!getCampaignStartDate(c),
        )

        const campaignsWithStartDateSorted = campaignsWithStartDate.sort(
          (a, b) => {
            const aStartDate =
              a.selfServeData.length && a.selfServeData[0].startDate
                ? moment(
                    moment(Number(a.selfServeData[0].startDate))
                      .utc()
                      .format()
                      .split('T')[0],
                    'YYYY-MM-DD',
                    true,
                  ).format()
                : a.startDate
                ? moment(a.startDate).format()
                : ''

            const bStartDate =
              b.selfServeData.length && b.selfServeData[0].startDate
                ? moment(
                    moment(Number(b.selfServeData[0].startDate))
                      .utc()
                      .format()
                      .split('T')[0],
                    'YYYY-MM-DD',
                    true,
                  ).format()
                : b.startDate
                ? moment(b.startDate).format()
                : ''
            return (
              new Date(bStartDate).getTime() - new Date(aStartDate).getTime()
            )
          },
        )

        const campaignsWithoutStartDateSorted = campaignsWithoutStartDate.sort(
          (a, b) => {
            return Number(b.createdAt) - Number(a.createdAt)
          },
        )

        newData = [
          ...campaignsWithoutStartDateSorted,
          ...campaignsWithStartDateSorted,
        ]

        return direction ? newData : newData.reverse()
      // case 'hardCosts':
      //    newData.sort((a, b) =>
      //     !a.costs ? 1 : !b.costs ? -1 : b.costs.hardCosts - a.costs.hardCosts,
      //   )

      default:
        return data
    }
  }

  const fetchSimpleCampaignsData = async (newVariables = {}, newData = []) => {
    const filterType = shouldFetchCampaignsByType
      ? [CAMPAIGN_TYPE_PARAM_TO_ENUM[type]]
      : null

    const filterStatus = shouldFetchActiveCampaigns
        ? [STATUS_CAMPAIGN_ENUM_ACTIVE]
        : selectedFilters.statuses[0] !== null
        ? selectedFilters.statuses
        : availableCampaignStatusesForClientRoles,
      controller = new AbortController()

    const filterSubType =
      isAdm || isEddm
        ? [subTypeEnum]
        : isEddmSignup
        ? [CAMPAIGN_SUBTYPES_ENUM.EDDM]
        : null

    const variables = {
      clientIds: [clientId],
      ...selectedFilters,
      statuses: filterStatus,
      types: filterType,
      subtypes: filterSubType,
      first: 5,
      skip: 0,
      ...newVariables,
    }

    try {
      const { hasNextPage, data } = await fetchCampaignsData({
        shouldFetchActiveDates: true,
        variables,
        signal: controller.signal,
      })

      let newCampaignData = [...newData, ...data]

      newCampaignData = applyCampaignShadowFilter(newCampaignData, userId)

      setCampaignsList(sortData(newCampaignData, sortByValue, sortDirection))
      setFilteredCampaignsList(
        sortData(newCampaignData, sortByValue, sortDirection),
      )
      if (hasNextPage) {
        fetchSimpleCampaignsData(
          {
            ...variables,
            skip: (variables.skip || 0) + variables.first,
          },
          newCampaignData,
        )
      } else {
        setIsLoadingCampaignsSimpleData(false)
      }
    } catch (e) {}
  }

  const getPageTitle = () => {
    if (shouldFetchActiveCampaigns) {
      return 'Active campaigns'
    } else if (shouldFetchCampaignsByType) {
      return CAMPAIGN_TYPE_PARAM_TO_CAMPAIGNS_DASHBOARD_TITLE[
        subType ? subType : type
      ]
    } else {
      return 'Campaigns'
    }
  }

  const renderCampaignCard = campaign => {
    const dashboardUrl = getCampaignDashboardUrl(campaign)
    const href =
      campaign.id && dashboardUrl
        ? `${PATHS.main.dashboard}${PATHS.dashboard.campaigns}/${
            campaign.id
          }/dashboard/${dashboardUrl}`
        : undefined

    return (
      <NewCampaignCard
        key={campaign.id}
        campaignId={campaign.id}
        handleDeleteCampaign={handleDeleteCampaign}
        handleDuplicateCampaign={handleDuplicateCampaign}
        campaignSimpleData={campaign}
        campaignCalculatedData={
          campaignCalculatedData.length
            ? campaignCalculatedData.find(
                calculatedCampaign => calculatedCampaign.id === campaign.id,
              )
            : {}
        }
        campaignOverviewHref={href}
        clientId={clientId}
        isSelfServeEnabled={client.isSelfServeEnabled}
      />
    )
  }

  const renderActiveCampaignsByType = () => {
    if (filteredCampaignsList.length) {
      const campaignsByType = filteredCampaignsList.reduce(
        (acc, campaign) => {
          if (campaign) {
            acc[campaign.type].push(campaign)
          }
          return acc
        },
        { HANDTOHAND: [], LETTERBOX: [], DIRECTMAIL: [], INSERTS: [] },
      )

      if (isEddmSignup) {
        return campaignsByType.DIRECTMAIL.length ? (
          <div className={classes.campaignChannelWrapper}>
            <Typography className={classes.campaignChannelTitle}>
              Direct mail
            </Typography>
            <div>{campaignsByType.DIRECTMAIL.map(renderCampaignCard)}</div>
          </div>
        ) : null
      }

      return (
        <Fragment>
          {campaignsByType.DIRECTMAIL.length ? (
            <div className={classes.campaignChannelWrapper}>
              <Typography className={classes.campaignChannelTitle}>
                Direct mail
              </Typography>
              <div>{campaignsByType.DIRECTMAIL.map(renderCampaignCard)}</div>
            </div>
          ) : null}
          {campaignsByType.HANDTOHAND.length ? (
            <div className={classes.campaignChannelWrapper}>
              <Typography className={classes.campaignChannelTitle}>
                Flyering
              </Typography>
              <div>{campaignsByType.HANDTOHAND.map(renderCampaignCard)}</div>
            </div>
          ) : null}
          {campaignsByType.LETTERBOX.length ? (
            <div className={classes.campaignChannelWrapper}>
              <Typography className={classes.campaignChannelTitle}>
                Door to door
              </Typography>
              <div>{campaignsByType.LETTERBOX.map(renderCampaignCard)}</div>
            </div>
          ) : null}
          {campaignsByType.INSERTS.length ? (
            <div className={classes.campaignChannelWrapper}>
              <Typography className={classes.campaignChannelTitle}>
                Inserts
              </Typography>
              <div>{campaignsByType.INSERTS.map(renderCampaignCard)}</div>
            </div>
          ) : null}
        </Fragment>
      )
    } else {
      return null
    }
  }

  const renderCampaignsCards = () => {
    if (shouldFetchActiveCampaigns) {
      return renderActiveCampaignsByType()
    } else {
      return <div>{filteredCampaignsList.map(renderCampaignCard)}</div>
    }
  }

  useEffect(() => {
    clearAllFilters()
    fetchSimpleCampaignsData({
      statuses:
        type && type === CAMPAIGN_VIEW_FILTER_TYPE.ACTIVE_CAMPAIGNS
          ? [STATUS_CAMPAIGN_ENUM_ACTIVE]
          : availableCampaignStatusesForClientRoles,
    })
    setIsLoadingCampaignsSimpleData(true)
    setIsLoadingCampaignCalculatedData(true)
    fetchCampaignCalculatedData({
      statuses:
        type && type === CAMPAIGN_VIEW_FILTER_TYPE.ACTIVE_CAMPAIGNS
          ? [STATUS_CAMPAIGN_ENUM_ACTIVE]
          : availableCampaignStatusesForClientRoles,
    })
    return () => {
      controller && controller.abort()
    }
  }, [type, subType])

  useEffect(() => {
    if (aborted) {
      setAborted(false)
      fetchSimpleCampaignsData()
      setIsLoadingCampaignsSimpleData(true)
      setIsLoadingCampaignCalculatedData(true)
      fetchCampaignCalculatedData()
    }
  }, [aborted])

  // useEffect(() => {
  //   if (sortByValue === 'hardCosts') {
  //     sortByHardCosts(campaignCalculatedData)
  //   }
  // }, [sortByValue, campaignCalculatedData])

  const handleDeleteCampaign = async campaignId => {
    await updateCampaign({
      campaignId,
      status: STATUS_CAMPAIGN_ENUM_ARCHIVE,
    })

    await insertCampaignLogs([
      {
        campaignId,
        type: CAMPAIGN_LOG_ENUM_TYPES.ARCHIVE_CAMPAIGN,
        additionalInfo: `Campaign was archived`,
      },
    ])
    setAborted(true)
  }

  const handleDuplicateCampaign = async campaignId => {
    try {
      const response = await duplicateUSEDDMCampaign({ campaignId })
      const result = await response.json()
      const duplicateResult = result.data && result.data.duplicateUSEDDMCampaign

      if (duplicateResult && duplicateResult.success) {
        await insertCampaignLogs([
          {
            campaignId: duplicateResult.campaignId,
            type: CAMPAIGN_LOG_ENUM_TYPES.CREATE_CAMPAIGN,
            additionalInfo: `Campaign duplicated from campaign ${campaignId}`,
          },
        ])
        setAborted(true) // Trigger refresh
        runSnackBar({
          type: 'success',
          msg: 'Campaign duplicated successfully',
        })
      } else {
        const errorMessage =
          (duplicateResult && duplicateResult.error) ||
          'Failed to duplicate campaign'
        runSnackBar({
          type: 'error',
          msg: errorMessage,
        })
      }
    } catch (error) {
      console.error('Error duplicating campaign:', error)
      runSnackBar({
        type: 'error',
        msg: 'Failed to duplicate campaign',
      })
    }
  }

  const createCampaign = async ({
    type: campaignType,
    subtype: campaignSubtype,
  } = {}) => {
    if (isCreatingCampaign) {
      return
    }
    const creationType = campaignType || CAMPAIGN_TYPE_PARAM_TO_ENUM[type]
    const creationSubType = campaignSubtype || subTypeEnum

    setIsCreatingCampaign(true)

    let campaignCount = Math.max(
      listOfAllClientCampaigns ? listOfAllClientCampaigns.length + 1 : 1,
    )

    const channelTitle = CAMPAIGN_ENUM_TYPES_TO_TITLE[creationType]

    const campaignNumber =
      campaignCount < 10
        ? `00${campaignCount}`
        : campaignCount >= 10 && campaignCount < 100
        ? `0${campaignCount}`
        : `${campaignCount}`

    const name = `${getBaseCampaignName(
      campaignType,
      type,
      subType,
    )} Campaign - ${campaignNumber}`

    if (posthog) {
      posthog.capture('Create New Campaign', {
        'event_category': channelTitle,
        'channel_name': name,
      })
    }

    const flyerType =
      (client.countryId == '14' || client.countryId === '16') &&
      creationType === CAMPAIGN_ENUM_TYPES.LETTERBOX
        ? DocumentFormats.DOOR_HANGER
        : creationSubType === CAMPAIGN_SUBTYPES_ENUM.EDDM
        ? EDDM_DOCUMENT_FORMATS.BEST_SELLER
        : creationSubType === CAMPAIGN_SUBTYPES_ENUM.ADM
        ? ADM_DOCUMENTS_FORMATS.POSTCARD_9x6
        : DocumentFormats.A6

    const flyerWeight =
      creationType === CAMPAIGN_ENUM_TYPES.DIRECTMAIL ? null : '250'

    const baPerLocation =
      creationType === CAMPAIGN_ENUM_TYPES.HANDTOHAND
        ? countrySettings.baPerLocation
        : null

    const response = await createSSCampaign({
      name,
      type: creationType,
      subtype: creationSubType,
      flyerType,
      flyerWeight,
      lastActiveStep: 'home',
      baPerLocation,
    })

    const { data } = await response.json()

    const { clientId, campaignId } = data.createSSCampaign

    gtagWrapper({
      event: 'ss_campaign_created',
      client_id: clientId.toString(),
      user_id: userId.toString(),
      campaign_id: campaignId.toString(),
    })

    const campaignBuilderPageUrl = getCampaignBuilderPageUrl({
      campaignId,
      clientId,
      lastActiveStep: 'home',
      channel: creationType,
      subtype: creationSubType,
    })
    const linkWithAuth = addAuthParamsToCampaignBuilderUrl(
      campaignBuilderPageUrl,
      clientId,
    )

    insertCampaignLogs([
      {
        campaignId,
        type: CAMPAIGN_LOG_ENUM_TYPES.CREATE_CAMPAIGN,
        additionalInfo: 'Campaign was created',
        userId: userId,
      },
    ])
    openLinkInSameTab(linkWithAuth)

    setIsCreatingCampaign(false)

    setAborted(true)

    return campaignId
  }

  const handleCreateCampaign = useCallback(
    debounce(async selectedChannel => {
      const campaignId = await createCampaign(selectedChannel)
      emitAnalyticsEvent(
        'Clicked on CTA in campaign list to start cb',
        campaignId,
        {
          clientCampaigns:
            listOfAllClientCampaigns && listOfAllClientCampaigns.length
              ? listOfAllClientCampaigns.length
              : 0,
          channel,
        },
      )
    }, 200),
    [listOfAllClientCampaigns],
  )

  const createCampaignDisabled = useMemo(
    () => isCreatingCampaign || !listOfAllClientCampaigns,
    [listOfAllClientCampaigns, isCreatingCampaign],
  )

  const shouldDisplayNewCampaignButton = () => {
    if (
      !isSelfServeEnabled ||
      (type &&
        type !== CAMPAIGN_VIEW_FILTER_TYPE.ACTIVE_CAMPAIGNS &&
        !countrySettings[
          CAMPAIGN_TYPE_PARAM_TO_ENABLED_CHANNEL[subType || type]
        ])
    )
      return null
    if (type === CAMPAIGN_VIEW_FILTER_TYPE.ACTIVE_CAMPAIGNS) {
      return (
        <div
          className={classes.newCampaignBtnWrapper}
          cypress_id={'newCampaignBtn'}
        >
          <EmptyStateDropdownBtn
            handleCreateCampaign={handleCreateCampaign}
            campaignOptions={campaignOptions}
            classes={classes}
          />
        </div>
      )
    } else {
      return (
        <div
          className={classes.newCampaignBtnWrapper}
          cypress_id={'newCampaignBtn'}
        >
          <Button
            variant="outlined"
            startIcon={<AddIcon />}
            onClick={() => handleCreateCampaign()}
            className={classes.newCampaignBtn}
            disabled={createCampaignDisabled}
          >
            New Campaign
          </Button>
        </div>
      )
    }
  }

  if (!isAdmEnabled && isAdm) {
    return null
  }

  return (
    <div
      className={classNames(
        classes.dashboardBackground,
        'CampaignView-dashboardBackground',
      )}
    >
      <Box className={classes.dashboardsWrapper}>
        {!shouldFetchActiveCampaigns && !shouldFetchCampaignsByType && (
          <StyledBreadcrumbs
            icon={<CampaignIcon />}
            breadcrumbs={[
              {
                label: 'Campaigns',
              },
            ]}
          />
        )}

        {isLoading ? (
          <div className={classes.centered}>
            <LoadingIndicator />
          </div>
        ) : shouldDisplayEmptyState() ? (
          <Box className={classes.campaignWrapper}>
            <PageTitle className={classes.title}>{getPageTitle()}</PageTitle>
            {!client.isSelfServeEnabled && (
              <CampaignsTotals
                campaignsTotalCount={
                  listOfAllClientCampaigns
                    ? listOfAllClientCampaigns.filter(
                        campaign =>
                          campaign.status !== STATUS_CAMPAIGN_ENUM_ARCHIVE,
                      )
                    : null
                }
                campaignCalculatedData={campaignCalculatedData}
                campaignsList={campaignsList}
                setExportContent={setExportContent}
              />
            )}
            <div className={classes.filtersWrapper}>
              <DashboardsFilters
                filters={filters}
                sortingOptions={sortOptions}
                selectedFilters={selectedFilters}
                sortByValue={sortByValue}
                handleFiltersChange={handleFiltersChange}
                handleSortingChange={handleSortingChange}
                handleSortDirectionChange={handleSortDirectionChange}
                sortDirection={sortDirection}
                isSelfServeEnabled={client.isSelfServeEnabled}
                clearAllFilters={clearAllFilters}
                disableSortDirection={disableSortDirection}
                isDmEnabled={isDmEnabled}
              />
              {shouldDisplayNewCampaignButton()}
            </div>

            {!client.isSelfServeEnabled && (
              <div className={classes.csvExportWrapper}>
                <div className={classes.exportCsv} onClick={handleExport}>
                  <ExportIcon />
                  <span>Export csv</span>
                </div>
              </div>
            )}

            <React.Fragment>
              {!listOfAllClientCampaigns || isLoadingCampaignsSimpleData ? (
                <LoadingIndicator />
              ) : filteredCampaignsList.length &&
                filteredCampaignsList.length > 0 ? (
                renderCampaignsCards()
              ) : (
                <div>Found 0 campaigns</div>
              )}
            </React.Fragment>
          </Box>
        ) : (
          <EmptyStateRouteManager
            route={type}
            subRoute={subType}
            handleCreateCampaign={handleCreateCampaign}
            client={client}
            isSelfServeEnabled={isSelfServeEnabled}
            enabledChannels={campaignOptions}
            isLoading={isLoading}
          />
        )}
      </Box>
    </div>
  )
}

export default withRouter(withStyles(styles)(CampaignView))
